import { render, staticRenderFns } from "./commonTemplate.vue?vue&type=template&id=2d7db98d&"
import script from "./commonTemplate.vue?vue&type=script&lang=js&"
export * from "./commonTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports